import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getPortName } from '../../../../utils/service';

const mapStateToProps = state => ({

})

const mapDispatchToProps = dispatch => (
  bindActionCreators({

  }, dispatch)
)

class SearchResultEmailByIP extends Component {
  render() {
    const { data } = this.props
    const { 
      ip_addr, risk_level, area_code, city, connection_type,
      country_code, country_code3, country_name, discover_date,
      dma_code, isp, latitude, longitude, organization, os, postal_code,
      region_code, state, state_code, threat, timezone, as_number,
      as_bgp_prefix, as_country_code, as_name, as_organization, as_registry,
      as_allocated_date, peer_asns, open_ports, domains
    } = data
    return (
      <div className="email-container">
        <h3>
          IP Information
        </h3>
        <table>
          <tbody>
            <tr>
              <td>IP Address :</td>
              <td>{ip_addr}</td>
            </tr>
            <tr>
              <td>Risk Level :</td>
              <td>{risk_level}</td>
            </tr>
            <tr>
              <td>Threat :</td>
              <td>{threat || ""}</td>
            </tr>
            <tr>
              <td>City :</td>
              <td>{city || ""}</td>
            </tr>
            <tr>
              <td>State :</td>
              <td>{state || ""}</td>
            </tr>
            <tr>
              <td>Country :</td>
              <td>{country_name || ""}</td>
            </tr>
            <tr>
              <td>Postal Code :</td>
              <td>{postal_code || ""}</td>
            </tr>
            <tr>
              <td>Area Code :</td>
              <td>{area_code || ""}</td>
            </tr>
            <tr>
              <td>DMA Code :</td>
              <td>{dma_code || ""}</td>
            </tr>
            <tr>
              <td>Region Code :</td>
              <td>{region_code || ""}</td>
            </tr>
            <tr>
              <td>Postal Code :</td>
              <td>{postal_code || ""}</td>
            </tr>
            <tr>
              <td>Longitude :</td>
              <td>{longitude || ""}</td>
            </tr>
            <tr>
              <td>Latitude :</td>
              <td>{latitude || ""}</td>
            </tr>
            <tr>
              <td>ISP :</td>
              <td>{isp || ""}</td>
            </tr>
            <tr>
              <td>Organization :</td>
              <td>{organization || ""}</td>
            </tr>
            <tr>
              <td>Timezone :</td>
              <td>{timezone || ""}</td>
            </tr>
            <tr>
              <td>OS :</td>
              <td>{os || ""}</td>
            </tr>
            <tr>
              <td>Discover Date :</td>
              <td>{discover_date || ""}</td>
            </tr>
            <tr>
              <td>Connection Type :</td>
              <td>{connection_type || ""}</td>
            </tr>
            <tr>
              <td>Domains :</td>
              <td>
                <ul>
                  { domains.map((item, index) =>
                    <li key={index}>{item}</li>
                  )}
                </ul>
              </td>
            </tr>
            <tr>
              <td>AS Number:</td>
              <td>{as_number || ""}</td>
            </tr>
            <tr>
              <td>AS BGP Prefix:</td>
              <td>{as_bgp_prefix || ""}</td>
            </tr>
            <tr>
              <td>AS Country Code:</td>
              <td>{as_country_code || ""}</td>
            </tr>
            <tr>
              <td>AS Registry:</td>
              <td>{as_registry || ""}</td>
            </tr>
            <tr>
              <td>AS Organization:</td>
              <td>{as_organization || ""}</td>
            </tr>
            <tr>
              <td>AS Allocated  :</td>
              <td>{as_allocated_date || ""}</td>
            </tr>
            <tr>
              <td>AS Name:</td>
              <td>{as_name || ""}</td>
            </tr>
          </tbody>
        </table>
        { peer_asns.map((item, index) =>
          <div key={index}>
            <h3>
              Peer ASN {index + 1}
            </h3>
            <table>
              <tbody>
                <tr>
                  <td>ASN :</td>
                  <td>{item.as_number || ""}</td>
                </tr>
                <tr>
                  <td>BGP Prefix :</td>
                  <td>{item.as_bgp_prefix || ""}</td>
                </tr>
                <tr>
                  <td>Country Code :</td>
                  <td>{item.as_country_code || ""}</td>
                </tr>
                <tr>
                  <td>Registry :</td>
                  <td>{item.as_registry || ""}</td>
                </tr>
                <tr>
                  <td>AS Name :</td>
                  <td>{item.as_name || ""}</td>
                </tr>
                <tr>
                  <td>Allocated :</td>
                  <td>{item.as_allocated_date || ""}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
        { 0 === open_ports.length ?
          <div />
          :
          <div>
            <h3>
              Opened Ports
            </h3>
            <table>
              <tbody>
                { open_ports.map((port, index) =>
                  <tr key={index}>
                    <td>{port} :</td>
                    <td>{getPortName(port)}</td>
                  </tr>
                )}
              </tbody>
              
            </table>
          </div>
        }
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchResultEmailByIP);